import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import AuthContext from '../../../contexts/AuthContext';

import '../../../index.css';
import closeIcon from '../../../icons/ic-paymentAgreement-close.png';
import ShopLink from './ShopLink';
import SelectShop from './SelectShop';
import {
  updateUser,
  getMakeShopProductList,
} from '../../../modules/NetworkFunction';

import { returnMessageFromCode } from '../../../utils/ErrorAlertComponent';

const Modal = styled.div`
  position: relative;
  width: 530px;
  height: 437px;
  padding: 0px 30px;
  background-color: #ffffff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  text-align: flex-start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

function MyPageShopLinkModal(props) {
  const { auth: token } = useContext(AuthContext);
  const { modalType, shopVersion, open, close, cafe24LinkState } = props;
  const [type, setType] = useState(modalType);
  const [selectedShop, setSelectedShop] = useState(shopVersion);
  const [cafe24SelectedShop, setCafe24SelectedShop] = useState();
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const [isMultiShopSelected, setIsMultiShopSelected] = useState(false);
  const isMakeShopData = useState(false)[0];

  const urlRegex = new RegExp(
    /^(http|https):\/\/((\w+)[.])+(kr|com|shop|net|biz|org|co.kr|or.kr|jp)/
  );

  const [makeShopData, setMakeShopData] = useState({
    url: '',
    shopKey: '',
  });

  useEffect(() => {
    setType(modalType);
    if (shopVersion !== '') {
      setSelectedShop(shopVersion);
    }
  }, [modalType, selectedShop]);

  const handleSelectShop = (option) => {
    setIsOptionSelected(option ? false : true);
    if (option === '카페24') {
      setSelectedShop('cafe24');
    } else {
      setSelectedShop('makeshop');
    }
  };

  const handleMultiShopSelect = (selected) => {
    setIsMultiShopSelected(selected ? false : true);
    setCafe24SelectedShop(selected);
  };

  const handleMakeShopData = (data) => {
    setIsMultiShopSelected(data ? false : true);
    setMakeShopData(data);
  };

  const handleSaveButton = async () => {
    if (type === 'selectShop') {
      setType('shopLink');
    } else {
      if (cafe24SelectedShop) {
        let userData = JSON.parse(sessionStorage.getItem('data'));
        localStorage.setItem('shopNo', cafe24SelectedShop.shop_no);

        userData = {
          ...userData,
          shopNo: Number(cafe24SelectedShop.shop_no),
          cafe24URL: `https://${cafe24SelectedShop.primary_domain}`,
          mallId: sessionStorage.getItem('mallId'),
        };
        updateUser(
          userData,
          () => {},
          () => {
            close();
            alert('연동되었습니다.');

            window.history.pushState({}, null, '/mypage/shop-link');
            window.location.reload();
            console.log('userData', userData);
          },
          (v) => {
            console.log(v);
            alert('연동에 실패했습니다. 다시 시도해주세요.');
          },
          token
        );
      }

      if (makeShopData.url && makeShopData.shopKey) {
        if (urlRegex.test(makeShopData.url)) {
          const makeshopDomain = new URL(makeShopData.url).hostname;
          await getMakeShopProductList(
            {
              shopDomain: makeshopDomain,
              shopKey: makeShopData.shopKey,
            },
            (d) => {
              console.log(d);
              if (d.return_code !== '0000') {
                // 0000: 성공
                // 실패한 경우엔 에러코드에 따라 다른 메시지를 띄워주고 return
                returnMessageFromCode(d.return_code);
                return;
              }
            },
            (e) => {
              console.log(e);
            },
            token
          );

          let userData = JSON.parse(sessionStorage.getItem('data'));
          localStorage.setItem('shopKey', makeShopData.shopKey);
          console.log('userData', userData);
          userData = {
            ...userData,
            makeshopURL: makeShopData.url,
            makeshopKey: makeShopData.shopKey,
          };

          console.log('updateUser', userData);
          updateUser(
            userData,
            () => {},
            () => {
              close();
              alert('연동되었습니다.');
              window.location.reload();
            },
            (v) => {
              console.log(v);
              alert('연동에 실패했습니다. 다시 시도해주세요.');
            },
            token
          );
        } else {
          alert('형식에 맞는 URL을 입력해주세요.');
        }
      } else {
        if (shopVersion === 'makeShop') {
          alert('내용을 입력해주세요.');
        }
      }
    }
  };

  return (
    <div className={open ? 'openModal modal' : 'modal'}>
      <Modal>
        <HeaderContainer>
          <ModalTitle>
            {type === 'selectShop'
              ? '연동할 쇼핑몰 추가하기'
              : selectedShop === 'cafe24'
              ? '카페24 연동하기'
              : '메이크샵 연동하기'}
          </ModalTitle>
          <CloseButton onClick={close} />
        </HeaderContainer>
        {type === 'shopLink' ? (
          <ShopLink
            shopVersion={selectedShop}
            cafe24LinkState={cafe24LinkState}
            multiShopSelected={handleMultiShopSelect}
            setMakeShop={handleMakeShopData}
          />
        ) : (
          <SelectShop onSelectShop={handleSelectShop} />
        )}
        <SaveButton
          disabled={
            type === 'selectShop'
              ? isOptionSelected
              : shopVersion === 'cafe24'
              ? isMultiShopSelected
              : isMakeShopData
          }
          onClick={handleSaveButton}
        >
          {type === 'selectShop' ? '다음' : '저장'}
        </SaveButton>
      </Modal>
    </div>
  );
}

export default MyPageShopLinkModal;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0 0 0;
`;

const ModalTitle = styled.div`
  font-size: 24px;
  font-weight: 400;
  color: #000;
`;

const CloseButton = styled.button`
  background-image: url(${closeIcon});
  background-size: cover;
  border: none;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  width: 32px;
  height: 32px;
  cursor: pointer;
`;

const SaveButton = styled.button`
  position: absolute;
  width: 101px;
  height: 39px;
  left: 216px;
  right: 216px;
  bottom: 32px;
  padding: 5px 32px 6px 32px;
  text-align: center;
  border-radius: 18.6px;
  font-size: 20px;
  font-weight: 700;
  border-width: 0;
  background-color: #ffb600;
  color: #fff;
  cursor: pointer;
`;
